import RefundModal from '@/components/manage/refund/RefundModal';
import RefundExtrasOverview from '@/components/manage/refund/extras/RefundExtrasOverview';
import { RefundExtrasSelection } from '@/components/manage/refund/extras/RefundExtrasSelection';
import { initiateExtrasRefund } from '@/features/manage/manageActions';
import { refundSelectedAncillariesSelector } from '@/features/manage/manageSelectors';
import { useDispatch, useSelector } from '@/store/utils';
import { useCallback, useMemo, type FC } from 'react';

interface RefundExtrasModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const RefundExtrasModal: FC<RefundExtrasModalProps> = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const selectedAncillaries = useSelector(refundSelectedAncillariesSelector);

  const selected = useMemo(
    () => Object.keys(selectedAncillaries).length,
    [selectedAncillaries]
  );

  const handleInitiateRefund = useCallback(async () => {
    await dispatch(initiateExtrasRefund()).unwrap();
  }, [dispatch]);

  return (
    <RefundModal
      isOpen={isOpen}
      refundSelection={RefundExtrasSelection}
      refundOverview={RefundExtrasOverview}
      selected={selected}
      chooseToRefundText="selectExtras"
      refundText="refundExtras"
      refundInitiatedText="extrasRefundInitiated"
      showBookingCode
      onInitiateRefund={handleInitiateRefund}
      onClose={onClose}
    />
  );
};

export default RefundExtrasModal;
